import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVector3 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 500,
	height: 300,
	viewBox: "-50 -150 1314 916",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		filter: "url(#filter0_df_3275_24491)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M983.734 569.095L1074.48 477.35C1126.3 424.97 1126.3 340.648 1074.48 288.269L1026.64 239.895C1001.38 214.366 966.967 200 931.059 200H387.384C329.951 200 283.393 246.558 283.393 303.991C283.393 331.375 272.592 357.653 253.334 377.122L155.858 475.666C130.963 500.834 117 534.806 117 570.207V581.565C117 655.811 177.189 716 251.435 716H356.784C392.692 716 427.108 701.634 452.361 676.105L479.286 648.885C504.539 623.355 538.955 608.99 574.863 608.99H888.157C924.066 608.99 958.482 594.624 983.734 569.095Z",
			fill: "url(#paint0_linear_3275_24491)"
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
		id: "filter0_df_3275_24491",
		x: -83,
		y: 0,
		width: 1396.34,
		height: 916,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 20 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 40 }),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_3275_24491"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_3275_24491",
				result: "shape"
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", {
				stdDeviation: 100,
				result: "effect2_foregroundBlur_3275_24491"
			})
		]
	}), /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_3275_24491",
		x1: 564.506,
		y1: 748.88,
		x2: 564.506,
		y2: 200,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#21EAB0" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#0BCE9F"
		})]
	})] })]
});
export default SvgVector3;
